<template>
	<div class="product-gallery">
		<div class="row mb-4">
			<div class="col">
				<div class="image-container large ratio ratio-1x1">
					<div class="mask"></div>
					<img :src="large(activeImage)" />
				</div>
			</div>
		</div>

		<div class="row-thumbs row row-cols-4 row-cols-md-8 g-1 g-md-2 gy-4">
			<div class="col" v-for="(image, index) in images" @click="activeIndex = index">
				<div class="image-container thumb ratio ratio-1x1">
					<div class="mask"></div>
					<img :src="thumb(image)" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		images: {
			required: true
		},
		type: {
			default: 'wordpress' // wordpress || mascus
		}
	},

	data() {
		return {
			activeIndex: 0,
		}
	},

	computed: {
		activeImage() {
			return this.images[this.activeIndex]
		}
	},

	methods: {
		large (image) {
			if (this.type === 'wordpress') {
				return image.sizes['product-gallery-full']
			}

			return image['#text']
		},
		thumb (image) {
			if (this.type === 'wordpress') {
				return image.sizes['product-gallery-thumb']
			}

			return image['#text']
		}
	}
}
</script>
